import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import ClassesAddPage from 'pages/classes/Add';
import CoursebatchesViewPage from 'pages/coursebatches/View';
import CoursesViewPage from 'pages/courses/View';
import TeachersViewPage from 'pages/teachers/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import VideoPlayer from './VideoPlayer';
const ClassesListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/classes/view/${data.class_id}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('classes/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/classes/edit/${data.class_id}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('classes/edit')
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.class_id) },
			icon: "pi pi-trash",
			visible: () => auth.canView('classes/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<Menubar className="p-0 " model={items} />);
	}
	function ClassIdTemplate(data){
		if(data){
			return (
				<Link to={`/classes/view/${data.class_id}`}> { data.class_id }</Link>
			);
		}
	}
	function CourseIdTemplate(data){
		if(data){
			return (
				<>{data.course_id && <Button className="p-button-text" icon="pi pi-eye" label="Courses" onClick={() => app.openPageDialog(<CoursesViewPage isSubPage apiPath={`/courses/view/${data.course_id}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function TeacherIdTemplate(data){
		if(data){
			return (
				<>{data.teacher_id && <Button className="p-button-text" icon="pi pi-eye" label="Teachers" onClick={() => app.openPageDialog(<TeachersViewPage isSubPage apiPath={`/teachers/view/${data.teacher_id}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function BatchnumberTemplate(data){
		if(data){
			return (
				<>{data.batchnumber && <Button className="p-button-text" icon="pi pi-eye" label="Coursebatches" onClick={() => app.openPageDialog(<CoursebatchesViewPage isSubPage apiPath={`/coursebatches/view/${data.batchnumber}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Delete Selected"/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-classes`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="" tooltip="Export" buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="classes/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="ClassesListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Classes"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Button label="Add New Class" icon="pi pi-plus"  onClick={()=>app.openPageDialog(<ClassesAddPage isSubPage apiPath={`/classes/add`} />, { closeBtn: true, width: '400'  })}  className="p-button w-full bg-primary "  />
                    </CanView>
                </div>
                <div className="col-12 md:col-3 " >
                    <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                    </span>
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <FilterTags filterController={filterController} />
                    <div >
                        <PageBreadcrumbs />
                        <div className="page-records">
                            <DataTable 
                                lazy={true} 
                                loading={loading} 
                                selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                value={records} 
                                dataKey="class_id" 
                                sortField={sortBy} 
                                sortOrder={sortOrder} 
                                onSort={onSort}
                                className=" p-datatable-sm" 
                                stripedRows={true}
                                showGridlines={false} 
                                rowHover={true} 
                                responsiveLayout="stack" 
                                emptyMessage={<EmptyRecordMessage />} 
                                >
                                {/*PageComponentStart*/}
                                <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                <Column  field="class_id" header="Class Id" body={ClassIdTemplate} sortable={true} ></Column>
                                <Column  field="course_id" header="Course Id" body={CourseIdTemplate} sortable={true} ></Column>
                                <Column  field="class_date" header="Class Date"  sortable={true} ></Column>
                                <Column  field="duration" header="Duration"  sortable={true} ></Column>
                                <Column  field="topic" header="Topic"  sortable={true} ></Column>
                                <Column  field="teacher_id" header="Teacher Id" body={TeacherIdTemplate} sortable={true} ></Column>
                                <Column  field="batchnumber" header="Batchnumber" body={BatchnumberTemplate} sortable={true} ></Column>
                                <Column headerStyle={{width: 'auto'}} headerClass="text-center" body={ActionButton}></Column>
                                {/*PageComponentEnd*/}
                            </DataTable>
                        </div>
                        <PageFooter />
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
	);
}
ClassesListPage.defaultProps = {
	primaryKey: 'class_id',
	pageName: 'classes',
	apiPath: 'classes/index',
	routeName: 'classeslist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default ClassesListPage;
